import FaqItems from "faqItems.mjs";
import { FaqItem } from "model/faq";

export interface FaqMap {
  [id: string]: FaqItem;
}
export interface FaqTagMap {
  [id: string]: FaqItem[];
}

export const getFaqMap = (): FaqMap => {
  const map: FaqMap = {};

  for (const group of FaqItems) {
    for (const item of group?.items || []) {
      map[item.id] = item;
    }
  }

  return map;
};

export const getFaqTagMap = (): FaqTagMap => {
  const map: FaqTagMap = {};

  for (const group of FaqItems) {
    for (const item of group?.items || []) {
      for (const tag of item?.tags || []) {
        if (!map[tag]) map[tag] = [];
        (map[tag] as FaqItem[]).push(item);
      }
    }
  }

  return map;
};

const defaults = {
  getFaqMap,
  getFaqTagMap,
};

export default defaults;
